/**
 * Le questionnaire de départ, en un seul endroit.
 *
 * C'est le fichier que votre associé doit pouvoir relire et corriger sans
 * toucher au reste : l'ordre des étapes, les intitulés et les choix vivent
 * ici, la mécanique de l'écran vit ailleurs.
 *
 * Règle de tri : on commence par ce qui est agréable à répondre (l'objectif),
 * on termine par ce qui coûte (le téléphone). L'inverse fait fuir.
 */

export type Choice = {
  value: string
  label: string
  /** Précision courte sous l'intitulé. Facultative : mieux vaut rien qu'un remplissage. */
  hint?: string
}

export type Question = {
  id: string
  /** `single` avance tout seul au choix ; `multi` attend une validation. */
  kind: "single" | "multi"
  title: string
  subtitle?: string
  choices: Choice[]
}

export const QUESTIONS: Question[] = [
  {
    id: "objectif",
    kind: "single",
    title: "Qu'est-ce qui vous amène ?",
    subtitle: "Il n'y a pas de mauvaise réponse, et ça se reprécise au téléphone.",
    choices: [
      {
        value: "poids",
        label: "Perdre du poids",
        hint: "Retrouver un poids où je me sens bien",
      },
      {
        value: "forme",
        label: "Me remettre en forme",
        hint: "Reprendre après une longue pause",
      },
      {
        value: "renforcement",
        label: "Me renforcer",
        hint: "Gagner en force et en tonus",
      },
      {
        value: "energie",
        label: "Avoir plus d'énergie",
        hint: "Mieux dormir, moins de coups de mou",
      },
    ],
  },
  {
    id: "depart",
    kind: "single",
    title: "Où en êtes-vous aujourd'hui ?",
    subtitle: "Pour que la première séance soit au bon niveau.",
    choices: [
      { value: "jamais", label: "Je n'ai jamais vraiment pratiqué" },
      {
        value: "arret",
        label: "J'ai arrêté depuis un moment",
        hint: "Plus d'un an sans activité régulière",
      },
      {
        value: "occasionnel",
        label: "Je bouge de temps en temps",
        hint: "Marche, vélo, un peu de sport",
      },
      {
        value: "regulier",
        label: "Je suis déjà régulier",
        hint: "Au moins une fois par semaine",
      },
    ],
  },
  {
    id: "rythme",
    kind: "single",
    title: "À quel rythme aimeriez-vous avancer ?",
    choices: [
      { value: "1", label: "Une séance par semaine" },
      {
        value: "2",
        label: "Deux séances par semaine",
        hint: "Le format le plus choisi",
      },
      { value: "3", label: "Trois séances ou plus" },
      {
        value: "inconnu",
        label: "Je ne sais pas encore",
        hint: "On en parle ensemble au téléphone",
      },
    ],
  },
  {
    id: "creneaux",
    kind: "multi",
    title: "Quand êtes-vous disponible ?",
    subtitle: "Plusieurs réponses possibles.",
    choices: [
      { value: "matin", label: "En matinée", hint: "Avant 12 h" },
      { value: "midi", label: "Sur la pause déjeuner" },
      { value: "apresmidi", label: "L'après-midi" },
      { value: "soir", label: "En soirée", hint: "Après 18 h" },
      { value: "weekend", label: "Le week-end" },
    ],
  },
]

/** Les questions, plus l'écran de coordonnées. Sert au fil d'avancement. */
export const TOTAL_STEPS = QUESTIONS.length + 1
